import { useCallback, useRef } from 'react';

import { Scroll, ScrollHandle } from '@dreryk/react-components';

import { FormsTemplateFormSection } from './form/FormsTemplateFormSection';
import { FormsTemplatesPortalContainer, FormsTemplatesRootPortalContainer } from './FormsTemplates.portal';
import { StyledFormsTemplates } from './FormsTemplates.styled';
import { isItemEmpty } from './FormsTemplates.utils';
import { FormsTemplatesCancelActionBarPrimaryLink } from './FormsTemplatesCancelActionBarPrimaryLink';
import { StyledFormsTemplatesMainContentSection } from './FormsTemplatesMainContentSection.styled';
import { StyledFormsTemplatesRoot } from './FormsTemplatesRoot.styled';
import { FormsTemplatesSendTemplateButton } from './FormsTemplatesSendTemplateButton';
import { FormsTemplatesEmptyStatePlaceholder } from './list/FormsTemplatesEmptyStatePlaceholder';
import { FormsTemplatesList } from './list/FormsTemplatesList';
import { StyledFormsTemplatesListSection } from './list/FormsTemplatesListSection.styled';
import { FormsTemplatesAddNewItemButton } from './modal/FormsTemplatesAddNewItemButton';
import { FormsTemplatesExitModalButtons } from './modal/FormsTemplatesExitModalButtons';
import { FormsTemplatesModal } from './modal/FormsTemplatesModal';
import { FormsTemplatesUseTemplateModalConfirmButton } from './modal/FormsTemplatesUseTemplateModalConfirmButton';
import { FormsTemplateReadOnlyInsertLink } from './readOnly/FormsTemplateReadOnlyInsertLink';
import { FormsTemplateReadOnlyNoInformation } from './readOnly/FormsTemplateReadOnlyNoInformation';
import { FormsTemplateReadOnlySection } from './readOnly/FormsTemplateReadOnlySection';
import { FormsTemplatesScrollContextProvider } from './scrollContext/formsTemplatesScrollContext';
import { FormsTemplateSearch } from './search/FormsTemplateSearch';
import { FormsTemplatesState } from './state/FormsTemplatesState';
import { withTemplateSaveButton } from './withTemplateSaveButton';

type FormsTemplateProps = {
   readonly children: JSX.Element;
};

// eslint-disable-next-line max-lines-per-function
export const FormsTemplates = (props: FormsTemplateProps): JSX.Element => {
   const scrollRef = useRef<ScrollHandle>(null);

   const scrollContentToTop = useCallback(() => {
      scrollRef.current?.scrollToTop();
   }, []);

   return (
      <StyledFormsTemplatesRoot>
         <FormsTemplatesRootPortalContainer />
         <FormsTemplatesScrollContextProvider value={{ scrollContentToTop: scrollContentToTop }}>
            <StyledFormsTemplates>
               <StyledFormsTemplatesListSection direction={'column'} gap={'8px'}>
                  <Scroll testId={'visitFormsLeftTemplates'}>{props.children}</Scroll>
               </StyledFormsTemplatesListSection>
               <StyledFormsTemplatesMainContentSection>
                  <Scroll ref={scrollRef} testId={'visitFormsTemplate'}>
                     <FormsTemplatesPortalContainer />
                  </Scroll>
               </StyledFormsTemplatesMainContentSection>
            </StyledFormsTemplates>
         </FormsTemplatesScrollContextProvider>
      </StyledFormsTemplatesRoot>
   );
};

FormsTemplates.Search = FormsTemplateSearch;
FormsTemplates.List = FormsTemplatesList;
FormsTemplates.State = FormsTemplatesState;
FormsTemplates.FormSection = FormsTemplateFormSection;
FormsTemplates.ReadOnlySection = FormsTemplateReadOnlySection;
FormsTemplates.ReadOnlyNoInformation = FormsTemplateReadOnlyNoInformation;
FormsTemplates.ReadOnlyInsertLink = FormsTemplateReadOnlyInsertLink;
FormsTemplates.ExitModalButtons = FormsTemplatesExitModalButtons;
FormsTemplates.Modal = FormsTemplatesModal;
FormsTemplates.AddNewItemButton = FormsTemplatesAddNewItemButton;
FormsTemplates.SendTemplateButton = FormsTemplatesSendTemplateButton;
FormsTemplates.UseTemplateModalConfirmButton = FormsTemplatesUseTemplateModalConfirmButton;
FormsTemplates.EmptyStatePlaceholder = FormsTemplatesEmptyStatePlaceholder;
FormsTemplates.CancelActionBarPrimaryLink = FormsTemplatesCancelActionBarPrimaryLink;
FormsTemplates.withTemplateSaveButton = withTemplateSaveButton;
FormsTemplates.isItemEmpty = isItemEmpty;
